

























import Vue from 'vue'
import videoMonitor from './video_monitor.vue'
import stationDataView from './station_data.vue';
import growth from './growth.vue'
import stationChart from './station_chart.vue'
import daily from './daily.vue'
import adminService from "@/service/adminService";
import request from '@/utils/request'
export default Vue.extend({
  components: {
    videoMonitor,
    stationDataView,
    growth,
    stationChart,
    daily
  },
  data() {
    return {
      stationList: [],
      selectedStation: {},
      isOptionsVisible: false,
      data: {},
      appKey: '',
      appSecret: '',
    }
  },
  watch: {
    selectedStation() {
      console.log(this.selectedStation)
      // @ts-ignore
      if (this.selectedStation.stationId === 'N3731') {
        // this.appKey = '01fa68dd1f0d4afd8fb72c317c9ae1f0'
        // this.appSecret = 'bedcea22b6b19271ff4787ae4e23371d'
        this.appKey = 'd826b10d95114b86bf8e614cf200616d'
        this.appSecret = 'd1695fc26645bbbd93c43348a281886e'
      }
      // @ts-ignore
      else if (this.selectedStation.stationId === 'N3010') {
        this.appKey = 'a0eeb9fd96304730b2ed0c5736c20a62'
        this.appSecret = 'd3606df7776ffae293da83806236ccc9'
      } else {

        this.appKey = 'd826b10d95114b86bf8e614cf200616d'
        this.appSecret = 'd1695fc26645bbbd93c43348a281886e'
      }
      this.getCyForecatData()
    }
  },
  mounted() {
    this.getStationList()
  },
  methods: {
    getStationList() {
      adminService.getStations("0,1").then((data: any) => {
        if (data && data.length > 0) {
          data.map((e: any) => {
            e.station_name = e.stationName;
            e.station_id_c = e.stationId;
            e.value = "";
          });
          this.stationList = data.filter((e: any) => {
            return e.url !== "" && e.url !== null;
          });
          this.selectedStation = this.stationList[0]
        }
      });
    },
    getCyForecatData() {
      // @ts-ignore
      const url = `/v2.5/realtime?point=${this.selectedStation.lon},${this.selectedStation.lat}`;
      request.get(url)
        .then(res => {
          this.data = res
        })

    },
    toggleOptions: function () {
      this.isOptionsVisible = !this.isOptionsVisible;
    },
    selectOption: function (option: any) {
      this.selectedStation = option;
      this.isOptionsVisible = false;
      console.log(this.selectedStation)
    },
  }
})

